<script>
	import { createEventDispatcher, getContext } from "svelte";
	import { dateToString, getDateLocales, stringToDate } from "@xbs/lib-todo";
	import { Calendar } from "@xbs/svelte-wx";
	import Popup from "./Popup.svelte";

	export let coords;
	export let cancel = null;
	export let value = null;
	export let convert = true;
	export let dateFormat = "%d %M %Y";

	const dispatch = createEventDispatcher();
	const _ = getContext("wx-i18n").getGroup("calendar");

	value =
		typeof value === "string"
			? stringToDate(value, dateFormat, true, getDateLocales(_))
			: value || null;

	const change = () => {
		if (value) {
			dispatch("change", {
				value: convert
					? dateToString(value, dateFormat, getDateLocales(_))
					: value,
			});
		} else {
			cancel && cancel();
		}
	};

</script>

<Popup {coords} on:cancel={change}>
	<Calendar on:change={change} bind:value />
</Popup>
